import { render } from "./Navbar.vue?vue&type=template&id=5d798efb&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=5d798efb&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/stc-frontend/stc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d798efb"]])

export default __exports__